import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Showcase from "@/components/site/Showcase";
import Features from "@/components/site/Features";
import Footer from "@/components/site/Footer";

export default function Landing() {
    return (
        <div
            className="tb-grain relative min-h-screen"
            data-testid="landing-page"
            style={{ background: "var(--tb-black)" }}
        >
            <Header />
            <main className="relative z-[2]">
                <Hero />
                <Showcase />
                <Features />
            </main>
            <Footer />
        </div>
    );
}
